/* gl_form_renderer.directive.js */

var _ = require("lodash");
var SteveUtils = require("@gluenetworks/steve_utilities");
var ArchMage = require("../../libs/Conjurer");
var q = require("q");
var StyleUtil = require("../../libs/StyleUtil");
let INLINE_LABELS_ENABLED_BY_DEFAULT = false;
let INHERIT_CONTAINER_LAYOUT = true;

/**
 * @typedef glFormRendererSettings
 * @property [configurationData] { ConfigurationData} The configuration data used to render the values in this form
 * @property [configurationSettings] {ConfigurationSettings} The type information necessary to conjur up this form.
 * @property [refInstances] {RefInstances} The Ref Instances needed for this Forms configurationSettings
 * @property [controlAdapterRegistry=AngularControlAdapterRegistry] {ControlAdapterRegistry} An object that represents a ControlAdapterRegistry.
 * @property [angularControlAdapterInitializer] {function} A Function responsible for linking/compiling/injecting the angular control adapters.
 */
module.exports = function (Logger, $compile, $injector, $timeout) {
    return {
        restrict: "E",
        scope: true,
        link: function ($scope, rootElem, iAttrs, controller) {
            var settings = {};
            //Setup external Settings
            if (iAttrs.hasOwnProperty("settings")) {
                var settingsName = iAttrs["settings"] || "settings";
                settings = SteveUtils.directive.getSettingsFromScope($scope, settingsName);
            }

            var options = _.defaults(
                {
                    angularControlAdapterInitializer: initializeAngularControlAdapter,
                },
                settings
            );
            //Set up Arch Mage
            $scope.archMage = new ArchMage(Logger, rootElem, options);

            //Set up the external API
            var api = $scope.archMage;

            //If the user wants to have direct access to the api set it up for them
            if (iAttrs["api"]) {
                var apiName = iAttrs["api"];
                SteveUtils.directive.attachApiToScope($scope, apiName, api);
            }

            /**
             * Initialize the Angular Control Adapter and Compile/Link it.
             * @param containerElement {DomElement} The container Element that wraps the Angular Control Adpapter.
             * @param fcd {FormControlDefinition} The Form Control Definition the describes the Angular Control Adapter.
             */
            function initializeAngularControlAdapter(containerElement, fcd) {
                var controlAdapter = fcd.adapterInfo.adapter;
                var initPromise;

                //If the control is Angular based lets run it through the compile and linking phases
                if (controlAdapter && controlAdapter.constructor.isAngularControl) {
                    //create Angular Control Adapters $scope
                    var newScope = $scope.$new(true);

                    //Add $scope to the fcd so it can be destroyed during tearDown
                    fcd.$scope = newScope;
                    newScope.jTypeContext = {
                        formDepth: 0,
                        layout: {
                            container: {
                                css: {},
                                cssClasses: [],
                                inheritLayout: INHERIT_CONTAINER_LAYOUT,
                            },
                            item: {cssClass: ""},
                            inlineLabels: INLINE_LABELS_ENABLED_BY_DEFAULT,
                        },
                        styleElement: undefined,
                    };
                    if ($scope.jTypeContext) {
                        newScope.jTypeContext.formDepth = $scope.jTypeContext.formDepth + 1;
                    } else {
                        let styleElement = StyleUtil.createStyleSheetElement(
                            containerElement[0].parentElement
                        );
                        let globalLayoutSettings = _.get(fcd, "layoutConfig", {});
                        let inlineLabelsClassList = StyleUtil.processInlineLabelsConfig(
                            globalLayoutSettings,
                            styleElement,
                            [StyleUtil.DEFAULT_INLINE_CLASS],
                            INLINE_LABELS_ENABLED_BY_DEFAULT,
                            "global"
                        );
                        $scope.jTypeContext = {
                            layout: {
                                container: {
                                    css: {},
                                    cssClasses: [],
                                    inheritLayout: _.get(
                                        globalLayoutSettings,
                                        "inheritLayout",
                                        INHERIT_CONTAINER_LAYOUT
                                    ),
                                },
                                inlineLabels: inlineLabelsClassList,
                            },
                            styleElement: styleElement,
                            formDepth: -1,
                        };
                        $scope.jTypeContext.layout.container =
                            StyleUtil.processContainerLayoutConfig(
                                globalLayoutSettings,
                                styleElement,
                                INHERIT_CONTAINER_LAYOUT,
                                "global"
                            );
                        let styleConfig = _.get(fcd, "styleConfig", {});
                        //apply this layout to root element of the entire jType/form
                        StyleUtil.renderStylesConfig(
                            styleConfig,
                            containerElement[0].parentElement
                        );
                        // if(!_.isEmpty($scope.jTypeContext.layout.container.cssClasses)) {
                        //     containerElement[0].parentElement.classList.add($scope.jTypeContext.layout.container.cssClasses);
                        // }
                    }
                    Object.assign(
                        newScope.jTypeContext,
                        StyleUtil.processLayoutConfig(
                            fcd.configSettings,
                            $scope.jTypeContext,
                            StyleUtil.DEFAULT_INLINE_CLASS,
                            fcd.adapterInfo.adapter.name
                        )
                    );

                    containerElement.addClass("form_depth_" + newScope.jTypeContext.formDepth);
                    //Compile/Link the Angular Control Adapter once its initialized
                    controlAdapter.once("InitializationComplete", function (evt) {
                        $compile(containerElement)(newScope);
                        //TODO Angular provides no way in knowing when a component is finished
                        //being compiled this is a hacky way to do it...
                        $timeout(function () {
                            //Notify the Angular Control Adapter that compile/link is complete
                            if (_.isFunction(controlAdapter.$compiledAndLinked)) {
                                //grab the providers
                                if (_.isArray(controlAdapter.$compiledAndLinked.$inject)) {
                                    $injector.invoke(
                                        controlAdapter.$compiledAndLinked,
                                        controlAdapter,
                                        {
                                            $scope: newScope,
                                        }
                                    );
                                } else {
                                    controlAdapter.$compiledAndLinked(newScope);
                                }
                            }
                        });
                    });

                    //Init the Angular Control Adapter
                    if (_.isFunction(controlAdapter.$init)) {
                        //grab the providers
                        if (_.isArray(controlAdapter.$init.$inject)) {
                            initPromise = $injector.invoke(controlAdapter.$init, controlAdapter, {
                                $scope: newScope,
                            });
                        } else {
                            //Launch the Angular portion of the Control Adapter
                            initPromise = controlAdapter.$init(newScope);
                        }
                    }
                }
                // Check if initPromise is a valid promise using duck typing
                // Don't rely on toString() as different promise libraries return different strings
                if (!initPromise || typeof initPromise.then !== "function") {
                    initPromise = q();
                }
                return initPromise;
            }
        },
    };
};

/*Generated Injectables*/
module.exports.$inject=['Logger','$compile','$injector','$timeout'];